<template>
  <div :class="from != 'introDetail' ? 'box4' : 'box4 no-padding'">
    <div class="box4__header">
      <pageTitle
        title="大模型测试&amp;AI智能体测试<br/>AI时代核心技能"
        text="AI驱动的测试对现代软件开发至关重要，传统测试方法已难以满足复杂软件系统的高效性和准确性需求"
        titleColor="#24375C"
        titColor="#86909C"
      />
    </div>

    <div class="card-list">
      <div
        v-for="(card, index) in cardList"
        :key="index"
        class="card"
        :class="`card--${index === 0 ? 'agent' : 'llm'}`"
      >
        <div
          class="card__badge"
          :style="{ backgroundImage: `url(${card.badge})` }"
        >
          <h3 class="card__name">{{ card.name }}</h3>
        </div>
        <div class="card-out">
          <div class="card__subtitle-bar">
            <p class="card__subtitle">{{ card.subtitle }}</p>
          </div>
          <ul class="card__list">
            <li
              v-for="(item, idx) in card.items"
              :key="idx"
              class="card__item"
            >
              <img
                src="../../../assets/coursePage/softwareTest/box4/bullet-icon.png"
                alt=""
                class="card__bullet"
              />
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
  },
  mounted() {
    this.from = this.getQueryString("from");
  },
  data() {
    return {
      from: "",
      cardList: [
        {
          name: "AI智能体测试",
          subtitle: "新兴蓝海：智能应用测试专家",
          badge: require("../../../assets/coursePage/softwareTest/box4/card-agent-badge.png"),
          items: [
            "AI测试快速入门（概念+质量模型）",
            "AI工具实战（数据生成/用例设计）",
            "核心方法（多任务/边界值模型测试）",
            "电商购物车AI功能全流程测试",
            "业务场景测试计划设计",
          ],
        },
        {
          name: "AI大模型测试",
          subtitle: "前沿阵地：大语言模型质控先锋",
          badge: require("../../../assets/coursePage/softwareTest/box4/card-llm-badge.png"),
          items: [
            "大模型原理与评估指标体系",
            "提示词工程与对抗性测试技巧",
            "性能与安全测试（红队/偏见检测）",
            "自动化评估框架与工具链实践",
            "企业级项目（智能客服/Al编程）测试",
          ],
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box4 {
  padding: 0px 0 80px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box4/bg.png")
    no-repeat center top;
  background-size: 100% 100%;
  background-origin: center bottom;

  &__header {
    padding: 0 32px;
  }

  /deep/ .course-text {
    padding: 0 4px;
  }

  .card-list {
    margin-top: 32px;
    padding: 0 32px;
  }

  .card {
    position: relative;
    width: 100%;
   
    box-shadow: 0px 2px 80px 0px rgba(57,76,121,0.1);
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    border-radius: 40px;
    overflow:hidden;
    .card-out{
      padding:40px;
    }
    &--agent {
      background-image: url("../../../assets/coursePage/softwareTest/box4/card-agent-bg.png");
    }

    &--llm {
      margin-top: 28px;
      z-index: 1;
      background-image: url("../../../assets/coursePage/softwareTest/box4/card-llm-bg.png");
    }

    &__badge {
      position: relative;
      
      max-width: 100%;
      height: 100px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 100% 100%;
    }

    &__name {
     
      margin: 0;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-size: 36px;
      font-weight: 600;
      color: #ffffff;
      line-height: 100px;
      padding-left:60px;
    }

    &__subtitle-bar {
      position: relative;
      padding-left:24px;
      width: 523px;
      max-width: 100%;
      height: 56px;
      border-radius: 10px;
      background: linear-gradient(
        270deg,
        rgba(244, 250, 255, 0) 0%,
        #e5f2ff 100%
      );
    }

    &__subtitle {
     
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 28px;
      color: #165DFF;
      line-height:56px;
      text-align: left;
      font-style: normal;
    }

    &__list {
      position: relative;
      z-index: 1;
      margin: 24px 0 0;
      padding: 0;
      list-style: none;
    }

    &__item {
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #24375C;
      line-height: 52px;
    }

    &__bullet {
      flex-shrink: 0;
      width: 32px;
      height: 32px;
      margin-right: 8px;
    }
  }
}

.no-padding {
  padding-top: 80px;
}
</style>
